import { render, staticRenderFns } from "./omolara_ibraheem_AjTeam.vue?vue&type=template&id=0b84eb44&scoped=true&"
import script from "./omolara_ibraheem_AjTeam.vue?vue&type=script&lang=js&"
export * from "./omolara_ibraheem_AjTeam.vue?vue&type=script&lang=js&"
import style0 from "./omolara_ibraheem_AjTeam.vue?vue&type=style&index=0&id=0b84eb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84eb44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
